import { Box, Tooltip, Typography } from "@mui/material";
import { exportIncomeTaxKeyPersonDetails, getIncomeTaxKeyPersonDetails, } from "api/services/automation/income-tax";
import SearchContainer from "components/SearchContainer";
import Table, { ColumnType } from "components/Table";
import sortHandler from "components/Table/SortHandler";
import useTitle from "hooks/useTitle";
import {  useState } from "react";
import { useMutation, useQuery } from "react-query";
import { ResType } from "types";
import moment from "moment";
import _ from "lodash";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import excelIcon from "./../.././assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import { designationMap, genderMap, getExpiryStatus, residentialStatusMap, yesNoMap } from "./constants";
import HorizontalTable from "components/Table/HorizontalTable";



const IncomeTaxKeyPersonDetails = () => {
  useTitle("ATOM Pro | Registered DSC's");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);


  const [sort, setSort] = useState<any>({});

  const { data, isLoading }: ResType = useQuery(
    [
      "income-tax-key-person-details",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        sort,
      },
    ],
    getIncomeTaxKeyPersonDetails,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
     
    }
  );


  let defaultColumns: Array<ColumnType> = [
   
    {
      key: "clientId",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      title: (
        <Box display="flex" alignItems="center">
          {/* <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} />  */}
          Assessee Name (PAN)
        </Box>
      ),
      render: (row) => (
        <Typography
        
           sx={{
            maxWidth: 180,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`${row?.credentials?.client?.displayName} (${row?.credentials?.panNumber})`}
        >
          {row?.credentials?.client?.displayName} (<span>{row?.credentials?.panNumber}</span>)
        </Typography>
      ),
    },
    {
      key: "din",
      title: "Designation (DIN)",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography sx={{
            maxWidth: 150,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={`${designationMap[row?.positionHeld] || "--"}${row?.din ? ` (${row.din})` : ""}`}
          >{designationMap[row?.positionHeld]} {row?.din && (<span>{`(${row?.din})` || "--"}</span>)}</Typography>
        );
      },
    },
    {
      key: "mbrPanTan",
      title: "Key Person (PAN)",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1" title={`${row?.mbrName || '--'} (${row?.mbrPanTan || "--"})`}>{row?.mbrName || '--'} ({row?.mbrPanTan || "--"})</Typography>
        );
      },
    },
    {
      key: "gender",
      title: "Gender",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{row?.gender? genderMap[row?.gender] : "--"}</Typography>
        );
      },
    },
    {
      key: "dateOfBirth",
      title: "DOB",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{ row?.dateOfBirth ? moment(row?.dateOfBirth).format('DD-MM-YYYY'): "--"}</Typography>
        );
      },
    },
    {
      key: "residentialStatus",
      title: "Residential Status",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{row?.residentialStatus ? residentialStatusMap[row?.residentialStatus] :  '--'}</Typography>
        );
      },
    },
    {
      key: "mobNo",
      title: "Mobile#",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1">{row?.mobNo || "--"}</Typography>
        );
      },
    },
    {
      key: "emailId",
      title: "Email ID",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC,
      // default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1" 
           sx={{
            maxWidth: 130,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={row?.emailId}
          >{row?.emailId || "--"}</Typography>
        );
      },
    },
    {
      key: "dscFlag",
      title: "DSC Status",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        return (
          <Typography variant="body1" color={row?.dscFlag === 'Y' ? 'success.main' : 'error.main'} sx={{fontWeight:'bold'}}>{row?.dscFlag ? yesNoMap[row?.dscFlag] : "--"}</Typography>
        );
      },
    },
    {
      key: "dscExpDate",
      title: "Expiry Date (Expires in day's)",
      sort: true,
      active: false,
      // direction: SortDirection.ASC,
      default: true,
      render: (row: any) => {
        const expiryStatus = getExpiryStatus(row?.dscExpDate);

        return (

<Typography variant="body1" >
  {row?.dscExpDate
    ? moment(row.dscExpDate).format("DD-MM-YYYY")
    : "--"}

  {row?.dscExpDate && (
    <span style={{ color: expiryStatus.color, marginLeft: 6 , fontWeight:450}}>
      ({expiryStatus.text})
    </span>
  )}
</Typography>        );
      },
    },

  ];
  const [columns, setColumns] = useState(_.cloneDeep(defaultColumns));


    const { mutate: mutate1, isLoading: isExporting } = useMutation(exportIncomeTaxKeyPersonDetails, {
      onSuccess: (res: any) => {
        const arr = new Uint8Array(res.data?.data);
        const blob = new Blob([arr], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const file = window.URL.createObjectURL(blob);
        const formattedDateTime = getCurrentFormattedDateTime();

        let link = document.createElement("a");
        link.href = file;
        link.download = `ATOM Pro - Income Tax (PAN) Key Person Details ${formattedDateTime}.xlsx`;
        link.click();
        snack.success("Income Tax (PAN) Key Person Details exported successfully");
      },
      onError: (err: any) => {
        snack.error(err);
        snack.error(handleError(err));
      },
    });
    const handleExport = () => {
      if (isExporting) return;
      mutate1({
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        
      });
    };
    
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
 

  const handleSearch = (e: any) => {
    setSearch(e);
    setPage(0);
  };

  return (
    <Box m={1}>
      <Box  sx={{ display: "flex", justifyContent:'space-between'}}>
     
        <SearchContainer
          minWidth="330px"
          value={search}
          debounced
          placeHolder=" Search by Assessee Name | PAN"
          onChange={handleSearch}
        />
         <Box display="flex" alignItems="center">
                 <Tooltip title={isExporting ? 'Exporting...' : 'Data Export to Excel'}>
                   <img
                     src={excelIcon}
                     alt="Export"
                     style={{
                       cursor: isExporting ? 'not-allowed' : 'pointer',
                       width: 33,
                       height: 33,
                       marginRight: "20px",
                       marginTop: "3px",
                       opacity: isExporting ? 0.5 : 1
                     }}
                     onClick={isExporting ? undefined : handleExport}
                   />
                 </Tooltip>
               </Box>
       
      </Box>

      <Box mt={1}>
        <HorizontalTable
          sx={{ pb: 0, mb: 0, height: "510px" }}
          pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
          data={data?.data.result || []}
          columns={columns}
          sortHandler={handleSort}
          loading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default IncomeTaxKeyPersonDetails;
